import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ThemeColorVariable, ThemeRadiusVariable, ThemeSpaceVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Button, useStyleConfig } from '@chakra-ui/react';
import { getISOWeek } from 'date-fns';
export const DatePickerWeekCell = ({ gridIndex, handleWeekChange, variant, date, selectWeek, isDisabled, }) => {
    const styles = useStyleConfig('DateCell', { variant });
    const row = Math.floor(gridIndex / 7) + 1;
    return (_jsx(_Fragment, { children: _jsx(Button, { sx: {
                color: variant === 'selectedDay'
                    ? ThemeColorVariable.OnAccent
                    : ThemeColorVariable.OnSurfaceSubdued,
                marginRight: ThemeSpaceVariable.None,
            }, borderRightRadius: 0, borderTopLeftRadius: ThemeRadiusVariable.Medium, borderBottomLeftRadius: ThemeRadiusVariable.Medium, __css: styles, type: "button", variant: variant, onClick: () => handleWeekChange(date), gridColumn: 1, gridRow: row, "data-testid": `week-number-${getISOWeek(date)}`, isDisabled: !selectWeek || isDisabled, ml: ThemeSpaceVariable.None, children: getISOWeek(date) }) }));
};
//# sourceMappingURL=datepicker-week-cell.js.map